import 'phaser';
import Scenes from '@Scenes';
import Game from './Game';

/**
 * Here we're keeping this here so that it doesn't expose a global to index.html
 * This may stop tampering and cheating.
 */

/*------------------ ON LOAD ---------------------*/

window.onload = function ()
{
    Game.boot(Scenes);
}